<template>
  <div
    v-loading="loading"
    class="l-page--inner l-page--search"
  >
    <div class="l-page__item u-mg-b-10">
      <el-form
        ref="filterParams"
        class="c-form c-condition__form"
        :model="filterParams"
        :inline="true"
        label-position="right"
        label-width="78px"
        label-suffix="："
      >
        <el-row class="c-form__row">
          <el-col
            class="c-form__col"
            :span="9"
          >
            <el-form-item
              class="c-form__item"
              label="评估状态"
              prop="pgzt"
            >
              <el-radio-group v-model="filterParams.pgzt">
                <el-radio label="">
                  全部
                </el-radio>
                <el-radio label="Y">
                  已完成
                </el-radio>
                <el-radio label="N">
                  未完成
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="8"
          >
            <el-form-item
              class="c-form__item"
              label="类型"
              prop="lx"
            >
              <el-select
                v-model="filterParams.lx"
                clearable
                class="c-form__select"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in lxType"
                  :key="item.id"
                  :value="item.id"
                  :label="item.text"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col o-form-btns"
            :span="7"
          >
            <k-button
              btn-text="查询"
              :auth-type="false"
              type="primary"
              icon="kestrel-icon ki-search"
              @click="search(1)"
            />
            <k-button
              btn-text="重置"
              :auth-type="false"
              icon="kestrel-icon ki-repeat"
              @click="resetForm"
            />
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="l-page__body l-page--search__body">
      <k-table
        ref="kTable"
        height="100%"
        :table-column="tableColumn"
        :pagination-show="true"
        :tooltip-effect="null"
        :data="page.rows"
        :pagination="page"
        @current-change="search"
        @size-change="handleSizeChange"
      >
        <template #jcnr="scope">
          <el-link
            type="primary"
            @click="openContent(scope.row)"
          >
            {{ scope.row.jcnr }}
          </el-link>
        </template>
        <template #jgdmMc="scope">
          {{ scope.row.jgdmMc || '未检查' }}
        </template>
      </k-table>
    </div>

    <content-dialog
      v-if="contentVisible"
      :visible="contentVisible"
      :xm-id="xmId"
      :xmnr-id="currentXmnrId"
      :buildings="buildings"
      :read-only="readOnly"
      @close="contentVisible = false"
      @saved="contentSaved"
    />
  </div>
</template>

<script>
import ContentDialog from './ContentDialog.vue';
import { pgExecutionService } from './execution.service';
import { pgxmManageService } from '../pgxm.service';

export default {
  name: 'PgxmList',
  components: { ContentDialog },
  data () {
    return {
      loading: false,
      catalog: [],
      buildings: [],
      contentVisible: false,
      currentXmnrId: '',
      filterParams: {
        lx: '',
        pgzt: ''
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 1
      },
      lxType: [
        { id: 'JZFH', text: '建筑防火' },
        { id: 'XFSS', text: '消防设施' },
        { id: 'XFAQGL', text: '消防安全管理' }
      ],
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'pglxMc', label: '专业', align: 'left', width: '130', type: 'text' },
        { key: 'dxMc', label: '评估子项', align: 'left', minWidth: '160', type: 'text' },
        { key: 'zxMc', label: '评估小项', align: 'left', minWidth: '160', type: 'text' },
        { key: 'jcnr', slotName: 'jcnr', label: '检查内容', align: 'left', minWidth: '240', type: 'text' },
        { key: 'bzyq', label: '标准要求', align: 'left', minWidth: '280', type: 'text' },
        { key: 'jcqk', label: '检查情况', align: 'left', minWidth: '200', type: 'text' },
        { key: 'jgdmMc', slotName: 'jgdmMc', label: '评定结果', align: 'left', width: '100', type: 'text' },
        { key: 'wtsl', label: '关联问题数', align: 'right', width: '100', type: 'text' },
        { key: 'fjsl', label: '现场图片数', align: 'right', width: '100', type: 'text' }
      ]
    };
  },
  computed: {
    xmId () {
      return this.$route.params.id;
    },
    readOnly () {
      return this.$route.name !== 'jxxfPgxmEdit';
    }
  },
  methods: {
    load () {
      this.loading = true;
      Promise.all([
        pgExecutionService.catalog(this.xmId),
        pgxmManageService.setting(this.xmId)
      ]).then(([catalogRsp, settingRsp]) => {
        this.catalog = (catalogRsp.data || {}).items || [];
        this.buildings = (settingRsp.data || {}).jzwList || [];
        this.search(1);
      }).finally(() => {
        this.loading = false;
      });
    },
    search (pageNo = 1) {
      const rows = this.catalog.filter(item => {
        const statusMatched = !this.filterParams.pgzt ||
          (this.filterParams.pgzt === 'Y' ? item.sfwc : !item.sfwc);
        return statusMatched && (!this.filterParams.lx || item.pglxDm === this.filterParams.lx);
      });
      const start = (pageNo - 1) * this.page.pageSize;
      this.page = Object.assign({}, this.page, {
        pageNo,
        total: rows.length,
        rows: rows.slice(start, start + this.page.pageSize)
      });
    },
    resetForm () {
      this.$refs.filterParams.resetFields();
      this.search(1);
    },
    handleSizeChange (value) {
      this.page.pageSize = value;
      this.search(1);
    },
    openContent (row) {
      this.currentXmnrId = row.xmnrId;
      this.contentVisible = true;
    },
    contentSaved () {
      this.contentVisible = false;
      this.load();
    }
  },
  created () {
    this.load();
  }
};
</script>

<style scoped>
.o-form-btns {
  display: flex;
  align-items: center;
  padding-left: 10px;
}
</style>
